// extracted by mini-css-extract-plugin
export default {"btn":"PopupButton_btn__d2lhV"};